module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTk2MCAyMzEuM1Y4MTZhMTYgMTYgMCAwIDEtMTYgMTZoLTg2NGExNiAxNiAwIDAgMS0xNi0xNlYyMzEuM2w0NDggMzIwIDQ0OC0zMjB6TTkwNSAxOTJsLTM5MyAyODAuNy0zOTMtMjgwLjdoNzg1Ljl6IiBmaWxsPSIjMCIgcC1pZD0iNDM3MSI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Email-filled.svg
// module id = 25hN
// module chunks = 75